<template>
  <div id="app">
    <!-- <button @click="handleSetSize('2')">换肤(小)</button>
		<button @click="handleSetSize('3')">换肤(中)</button>
		<button @click="handleSetSize('4')">换肤(大)</button> -->
    <!-- <div class="form-title">nihao</div> -->
    <commonTip :iType="1" :titleStr="tipStr" v-show="isShowWsState"></commonTip>
    <audio id="audio" :src="nowAudioUrl" style="display: none"></audio>
    <audio
      id="newUserAudio"
      :src="newUserAudioUrl"
      style="display: none"
    ></audio>
    <audio id="keyAudio" :src="keyAudioUrl" style="display: none"></audio>
    <div id="nav">
      <router-link to="/"></router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
import commonTip from "./components/commonTip.vue";
import { codeAndTips } from "@/utils/websocket.js";
import { applyLayoutCssVars } from "@/utils/layout.js";
export default {
  name: "App",
  data() {
    return {
      tipStr: "",
      isShowWsState: false,
      isShowLoad: false,
      beforeUnloadTime: 0,
      gapTime: 0,
    };
  },

  components: {
    commonTip,
  },

  computed: {
    // nowWsState() {
    // 	console.log('app computed nowWsState tag = ', this.$store.state.authority.wsStateTag)

    // 	return this.$store.state.authority.wsStateTag
    // 	// return this.$store.state.isOnline
    // },

    nowAudioUrl() {
      console.log(
        "app computed nowAudioUrl = ",
        localStorage.getItem("flickerAudioUrl")
      );
      return localStorage.getItem("flickerAudioUrl");
    },
    newUserAudioUrl() {
      console.log(
        "app computed newUserAudioUrl = ",
        localStorage.getItem("newaudioUrl")
      );
      return localStorage.getItem("newaudioUrl");
    },
    keyAudioUrl() {
      console.log(
        "app computed keyAudioUrl = ",
        localStorage.getItem("keyAudioUrl")
      );
      return localStorage.getItem("keyAudioUrl");
    },

    nowTheme() {
      return this.$store.state.currentTheme;
    },

    isOnline() {
      return this.$store.state.isOnline;
    },
    pingTips() {
      return this.$store.getters.getPingTips;
    },

    fontSize() {
      return this.$store.state.fontSize;
    },
  },

  watch: {
    // nowWsState: function (newVal, oldVal) {
    // 	console.log('app watch nowWsState newVal = ', newVal)
    // 	console.log('app watch nowWsState oldVal = ', oldVal)

    // 	if (newVal == 2 && oldVal == 1) {
    // 		if(localStorage.getItem("token")!=null || localStorage.getItem("token")!='null'){
    // 			this.tipStr = '网络已断开，正在重连中...'
    // 			this.isShowWsState = true
    // 			this.util.playErrTipAudio()
    // 		}

    // 		//connectWebsocket2()

    // 	} else if (newVal == 1 && oldVal == 2) {
    // 		this.tipStr = '网络已连接成功'
    // 		this.isShowWsState = true

    // 		setTimeout(() => {
    // 			console.log('app watch nowWsState setTimeout')
    // 			this.isShowWsState = false
    // 		}, 5000);
    // 	}else if(newVal == 0){
    // 		// setTimeout(() => {
    // 		// 	console.log('app watch nowWsState setTimeout')

    // 		// }, 2000);

    // 		this.isShowWsState = false
    // 	}
    // },

    nowTheme(newVal, oldVal) {
      console.log("app watch nowTheme newVal = ", newVal);
      console.log("app watch nowTheme oldVal = ", oldVal);
      if (newVal === "0") {
        import("./theme/theme1.css");
      } else if (newVal === "1") {
        import("./theme/theme2.css");
      }
    },

    pingTips(newVal, oldVal) {
      console.log("app watch pingTips newVal = ", newVal);
      console.log("app watch pingTips oldVal = ", oldVal);
      if (newVal.code != null) {
        this.tipStr = newVal.tipsText;
        this.isShowWsState = true;
        if (newVal.code == codeAndTips.offlineCode) {
          this.util.playErrTipAudio();
        } else if (newVal.code == codeAndTips.connectedCode) {
          setTimeout(() => {
            this.isShowWsState = false;
          }, 2000);
        }
      } else {
        this.isShowWsState = false;
      }
    },

    // fontSize(newVal,oldVal) {
    // 	console.log('app watch fontSize newVal = ', newVal)
    // 	console.log('app watch fontSize oldVal = ', oldVal)

    // 	if(newVal != null) {
    // 		window.document.documentElement.setAttribute('data-size', newVal)
    // 	}
    // }

    // isOnline(newVal, oldVal) {
    // 	var self = this;
    // 	let wsState = self.util.getLocalWsState();
    // 	if (newVal == true && oldVal == false) {
    // 		if (wsState == '2') {
    // 			setTimeout(() => {
    // 				connectWebsocket2()

    // 				// self.netWork();
    // 			}, 2000);
    // 		}
    // 	}
    // }
  },

  created() {
    console.log(
      "app created function isVisibility = ",
      document.visibilityState
    );

    let fontSize = localStorage.getItem("fontSize");
    if (!fontSize) {
      window.document.documentElement.setAttribute("data-size", "2");
    } else {
      window.document.documentElement.setAttribute("data-size", fontSize);
    }
    this.applyLayoutProfile();
    window.addEventListener("resize", this.applyLayoutProfile);

    let theme = this.$store.state.currentTheme;
    console.log("app created function theme = ", theme);
    if (theme === "0") {
      import("./theme/theme1.css");
    } else if (theme === "1") {
      import("./theme/theme2.css");
    }

    // 获取特殊显示关键字
    this.getSpecialDisplayKeywords();

    window.addEventListener("storage", function (e) {
      let audio;
      console.log("storage e==========", e);
      if (e.key == "fontSize") {
        window.document.documentElement.setAttribute("data-size", e.newValue);
      } else if (e.key == "flickeraudiourl") {
        audio = document.getElementById("audio");
        audio.src = e.newValue;
      } else if (e.key == "newaudiourl") {
        audio = document.getElementById("newUserAudio");
        audio.src = e.newValue;
      } else if (e.key == "keyAudioUrl") {
        audio = document.getElementById("keyAudio");
        audio.src = e.newValue;
        console.log("关键词提示音url：", audio.src);
      } else if (e.key == "volume") {
        const volume = e.newValue;
        const audioList = document.querySelectorAll("audio");
        for (const item of audioList) {
          item.volume = volume;
        }
        console.log("App.vue created storage", volume, audioList);
      }
    });
  },

  mounted() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e));
    window.addEventListener("unload", (e) => this.unloadHandler(e));

    if (window.performance.navigation.type == 1) {
      if (this.util.getLoginTip() === "1") {
        if (this.$route.path === "/home") {
          return;
        }

        // connectWebsocket2()
      }
    } else {
      console.log("首次被加载！");
    }
  },

  destroyed() {
    window.removeEventListener("beforeunload", (e) =>
      this.beforeunloadHandler(e)
    );
    window.removeEventListener("unload", (e) => this.unloadHandler(e));
    window.removeEventListener("resize", this.applyLayoutProfile);
  },

  methods: {
    beforeunloadHandler() {
      this.beforeUnloadTime = new Date().getTime();
    },
    async unloadHandler() {
      this.gapTime = new Date().getTime() - this.beforeUnloadTime;
      // debugger
      /*if (this.gapTime <= 5) {
					if (this.util.getLocalAccount().status == 1) {
						var api = "/manager/user/logOut";
						await this.util.postRequest({
							url: api,
							method: "POST",
						});
					}
				}*/
    },

    switchMode(mode) {
      if (!mode || mode === "dark") {
        window.document.documentElement.setAttribute("data-theme", "dark");
      } else {
        window.document.documentElement.setAttribute("data-theme", "bright");
      }
    },

    applyLayoutProfile() {
      const { compact } = applyLayoutCssVars(window.document.documentElement);
      if (compact) {
        const inputH = parseInt(this.$store.state.inputHeight, 10) || 130;
        if (inputH > 80) {
          this.$store.state.inputHeight = "80px";
        }
      } else {
        const saved = JSON.parse(localStorage.getItem("inputHeight"));
        this.$store.state.inputHeight = saved ? saved + "px" : "130px";
      }
      window.dispatchEvent(new CustomEvent("layout-profile-change"));
    },
    handleSetSize(size) {
      window.document.documentElement.setAttribute("data-size", size);
    },
    setLocalFlickerUrl(url) {
      this.$store.state.flickerAudioUrl = url;
    },

    // 获取特殊显示关键字
    async getSpecialDisplayKeywords() {
      try {
        const api = "/manager/sysconf/getSpecialDisplayKeywords";
        const res = await this.util.postRequest({
          url: api,
          method: "POST",
        });
        console.log("App.vue getSpecialDisplayKeywords res = ", res);
        if (res.resultCode === "10000" && res.data) {
          // 将分号分隔的字符串转换为数组
          const keywordsArray = res.data.split(";").filter(keyword => keyword.trim() !== "");
          this.$store.state.specialDisplayKeywords = keywordsArray;
          console.log("App.vue specialDisplayKeywords = ", keywordsArray);
        } else {
          console.warn("获取特殊显示关键字失败:", res.desc);
          this.$store.state.specialDisplayKeywords = [];
        }
      } catch (error) {
        console.error("获取特殊显示关键字异常:", error);
        this.$store.state.specialDisplayKeywords = [];
      }
    },
  },
};
</script>

<style lang="scss">
// @import './mixin.scss';

html {
  height: 100%;
  overflow: hidden;
  background: #fff;
  --sidebar-w: 57px;
  --sidebar-avatar: 30px;
  --sidebar-icon: 20px;
  --sidebar-nick-w: 52px;
  --quick-min-pct: 13%;
  --quick-min-px: 240px;
  --quick-max-px: 320px;
  --mydia-w: 150px;
}

#app,
body {
  /* background-color: yellow; */
  width: 100%;
  height: 100%;
  // min-width: 75rem;
  // min-height: 62.5rem;
  overflow: hidden;
  /* overflow-x: scroll; */
  // background: linear-gradient(to bottom right, #7a88ff, #7affaf);
  /* text-align: center; */
}

* {
  margin: 0;
  padding: 0;
}

.form-title {
  font-size: 18px;
  color: cyan;
  // @include header_font_color();
  // @include important-text;
  @include change_size($font_size_normal);
}

/* 720 等矮屏：收紧间距，顶部用户栏完整展示，消息列表吃剩余高度 */
html[data-compact="1"] {
  .chat_container .header {
    height: auto !important;
    flex-shrink: 0;
    align-items: stretch;
  }
  .chat_container .item {
    height: auto !important;
    justify-content: flex-start;
    padding: 0;
  }
  .chat_container .first_div {
    height: auto !important;
    min-height: 24px;
    flex-wrap: wrap;
  }
  .chat_container .name_div {
    height: auto !important;
    min-height: 20px;
    line-height: 1.35;
    margin-left: 8px !important;
  }
  .chat_container .btn_div,
  .chat_container .btn_div1 {
    margin-left: 6px !important;
    margin-top: 0 !important;
    height: auto !important;
    min-height: 18px !important;
    width: auto !important;
    padding: 0 6px !important;
    line-height: 1.2 !important;
  }
  .chat_container .add_tag {
    width: auto !important;
    min-width: 48px !important;
    height: auto !important;
    min-height: 18px !important;
    padding: 1px 4px !important;
  }
  .chat_container .tag_item {
    height: auto !important;
    min-height: 18px !important;
    padding: 1px 4px !important;
  }
  .chat_container .tag_div {
    height: 22px !important;
    margin-left: 8px !important;
  }
  .chat_container .other_div {
    height: auto !important;
    padding: 0 0 2px !important;
    flex-wrap: wrap;
    margin-left: 8px !important;
  }
  .chat_container .mark_div {
    height: 18px !important;
    line-height: 18px !important;
    margin-bottom: 0 !important;
  }
  .chat_container .key_container {
    padding: 0 !important;
    width: 98% !important;
  }
  .chat_container .chatBox {
    padding-top: 2px !important;
    flex: 1;
    min-height: 0;
    height: auto !important;
  }
  .chat_container .header_line {
    height: 2px !important;
  }
  .web__msg {
    height: 80px !important;
    padding: 0 6px !important;
  }
  .web__msg-input {
    font-size: 12px !important;
    line-height: 16px !important;
  }
  .scroller {
    width: 100% !important;
    padding: 6px 12px !important;
    box-sizing: border-box;
  }
  .web__main-text,
  .web__main-sys {
    font-size: 12px !important;
    line-height: 1.25 !important;
    padding: 0 8px !important;
  }
  .web_main-systip {
    padding: 1px 6px !important;
    line-height: 1.25 !important;
    margin: 0 !important;
  }
  .web__main-user img {
    width: 22px !important;
    height: 22px !important;
  }
  .web__main-item {
    padding-left: 32px !important;
    margin-bottom: 4px !important;
  }
  .web__main-item--mine {
    padding-left: 0 !important;
    padding-right: 32px !important;
  }
  .web__main-item--sys {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-bottom: 3px !important;
  }
  .web__main-user cite {
    padding-left: 6px !important;
  }
  .web__main-item--mine .web__main-user cite {
    right: 32px !important;
  }
  .web__main-user cite i {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
  .msg-row {
    padding-top: 18px !important;
  }
  .msg-warn-icon {
    margin-top: 30px !important;
  }
  .icon_box {
    height: 24px !important;
  }
  .el-button--mini {
    padding: 2px 6px !important;
    font-size: 11px !important;
    height: 20px !important;
    line-height: 16px !important;
  }
  .el-button--mini [class*="el-icon-"] {
    font-size: 12px !important;
  }
  .tools_div {
    height: 28px !important;
  }
  .tools_div .btn_div,
  .tools_div .end_div,
  .tools_div .btn_div1,
  .tools_div .btn_div2,
  .tools_div .btn_div3 {
    height: 24px !important;
    width: 42px !important;
    margin-left: 4px !important;
    margin-right: 4px !important;
  }
  .tools_div .btn_icon {
    width: 12px !important;
    height: 10px !important;
  }
  .web__tools .btn_div01,
  .web__tools .btn_div02,
  .web__tools .btn_div03,
  .web__tools .btn_div04,
  .web__tools .btn_div,
  .web__tools .end_div,
  .web__tools .btn_div1,
  .web__tools .btn_div2,
  .web__tools .btn_div3 {
    height: 24px !important;
    margin-left: 4px !important;
    margin-right: 4px !important;
  }
  .web__tools .file_div {
    width: 12px !important;
    height: 10px !important;
  }
  .el-tabs__item {
    height: 32px !important;
    line-height: 32px !important;
    font-size: 12px !important;
  }

  /* 首页各处图标缩小 */
  .left_container .img_div {
    width: 30px !important;
    height: 30px !important;
  }
  .left_container .header_icon {
    width: 19px !important;
    height: 19px !important;
  }
  .left_container .icon_img {
    width: 12px !important;
    height: 12px !important;
  }
  .aside_div_icon {
    width: 14px !important;
    height: 14px !important;
  }
  .telescoping-img {
    width: 14px !important;
    height: 14px !important;
  }
  .device_div,
  .brower_div {
    width: 10px !important;
    height: 10px !important;
  }
  .trusteeship {
    width: 12px !important;
    height: 12px !important;
  }
  .progress_icon {
    width: 12px !important;
    height: 12px !important;
  }
  .common-avatar {
    width: 18px !important;
    height: 18px !important;
  }
  .quick_btn img {
    width: 12px !important;
    height: 10px !important;
  }
  .deparrow_div img,
  .arrow_div img {
    width: 14px !important;
    height: 14px !important;
  }
  .eyes-icon {
    height: 10px !important;
    width: auto !important;
    max-width: 16px !important;
  }
  .web__tools i,
  .icon_box i {
    font-size: 12px !important;
  }
  .btn_icon,
  .file_div {
    width: 12px !important;
    height: 10px !important;
  }
  .history_div img,
  .history_img {
    width: 12px !important;
    height: 12px !important;
  }
  .el-collapse-item__arrow {
    font-size: 12px !important;
  }
  .el-button--mini [class*="el-icon-"] {
    font-size: 11px !important;
  }
}

/* body {
		width: 80vw;
		height: 100vh;
		min-width: 75rem;
		overflow: hidden;
		overflow-x: scroll;
		background: linear-gradient(to bottom right, #7a88ff, #7affaf);
		text-align: center;
	} */

/* body {
		background-color: yellow;
	} */
</style>
